var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { Box, Stack, Select, MenuItem, IconButton, } from '@mui/material';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from '../../components/buttonComponent/CustomButton';
import CreateApplicationButton from '../../components/uiComponents/startApplicationDialog/CreateApplicationButton';
import CommonTab from '../../components/tabComponent/CommonTab';
import BacklogTableSection, { allBacklogColumns, defaultVisibleColumnKeys, FIXED_COLUMN_KEYS } from './BacklogTableSection';
import { useBacklogApplication } from './useBacklogApplication';
import Filter from './Filter';
import ColumnSettings from './ColumnSettings';
import ActiveFilterChipsRow from './components/ActiveFilterChipsRow';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import BacklogApplicationCardView from './BacklogApplicationCardView';
import { BacklogViewWrapper } from './BacklogApplicationStyles';
import BacklogPagination from './components/BacklogPagination';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { baseColors } from '../../Themes/colors';
import { useDispatch, useSelector } from 'react-redux';
import { backlog_actions } from '../../actions/backlog_actions';
var BacklogApplication = function () {
    var _a, _b;
    var navigate = useNavigate();
    var location = useLocation();
    var navigationType = useNavigationType();
    var dispatch = useDispatch();
    var activeTab = useSelector(function (state) { var _a; return (_a = state.BacklogFilter.activeTab) !== null && _a !== void 0 ? _a : 0; });
    var activeDealCategory = activeTab === 0 ? 'BACKLOG_QUEUE' : 'ALL_DEALS';
    var _c = useBacklogApplication({ dealCategory: activeDealCategory }), backlogAppList = _c.backlogAppList, isFetching = _c.isFetching, selectedStatus = _c.selectedStatus, selectedSavedFilter = _c.selectedSavedFilter, searchText = _c.searchText, vendorList = _c.vendorList, selectedVendor = _c.selectedVendor, currentPage = _c.currentPage, setCurrentPage = _c.setCurrentPage, perPageCount = _c.perPageCount, setPerPageCount = _c.setPerPageCount, totalCount = _c.totalCount, navConfig = _c.navConfig, handleResetFilters = _c.handleResetFilters, programsList = _c.programsList, fetchProgramsByVendor = _c.fetchProgramsByVendor, salesRepList = _c.salesRepList, fetchSalesRepList = _c.fetchSalesRepList, dealerList = _c.dealerList, dealerListLoading = _c.dealerListLoading, dealerListLoadingMore = _c.dealerListLoadingMore, dealerListHasMore = _c.dealerListHasMore, dealerListError = _c.dealerListError, fetchDealersByVendor = _c.fetchDealersByVendor, searchDealerList = _c.searchDealerList, loadMoreDealerList = _c.loadMoreDealerList, selectedPrograms = _c.selectedPrograms, applyBacklogFilters = _c.applyBacklogFilters, selectedUniqueStatus = _c.selectedUniqueStatus, allUniqueStatusList = _c.allUniqueStatusList, setSelectedSavedFilter = _c.setSelectedSavedFilter, sortBy = _c.sortBy, sortOrder = _c.sortOrder, handleTableSortChange = _c.handleTableSortChange, selectedSalesRep = _c.selectedSalesRep, selectedDealers = _c.selectedDealers, selectedForecastDataRange = _c.selectedForecastDataRange;
    useEffect(function () {
        if (navigationType === 'POP') {
            return;
        }
        var navigationState = location.state;
        var hasNavigationTab = Boolean(navigationState && Object.prototype.hasOwnProperty.call(navigationState, 'activeTab'));
        if (hasNavigationTab) {
            var nextActiveTab = (navigationState === null || navigationState === void 0 ? void 0 : navigationState.activeTab) === 1 ? 1 : 0;
            dispatch(backlog_actions.setActiveTab(nextActiveTab));
            return;
        }
        dispatch(backlog_actions.setActiveTab(0));
        dispatch(backlog_actions.resetAllDealsFilters());
    }, [dispatch, location.key, location.state, navigationType]);
    var _d = useState('list'), viewMode = _d[0], setViewMode = _d[1];
    var _e = useState(false), filterOpen = _e[0], setFilterOpen = _e[1];
    var _f = useState(false), columnSettingsOpen = _f[0], setColumnSettingsOpen = _f[1];
    var _g = useState(false), hasColumnCustomization = _g[0], setHasColumnCustomization = _g[1];
    var _h = useState(true), isColumnConfigLoading = _h[0], setIsColumnConfigLoading = _h[1];
    var persistedVisibleColumnKeys = useSelector(function (state) { return state.BacklogFilter.visibleColumnKeys; });
    var visibleColumnKeys = hasColumnCustomization
        ? persistedVisibleColumnKeys
        : ((persistedVisibleColumnKeys === null || persistedVisibleColumnKeys === void 0 ? void 0 : persistedVisibleColumnKeys.length) ? persistedVisibleColumnKeys : defaultVisibleColumnKeys);
    var setVisibleColumnKeys = useCallback(function (keys) {
        dispatch(backlog_actions.setVisibleColumns(keys));
    }, [dispatch]);
    var _j = useState([]), fetchedSavedFilters = _j[0], setFetchedSavedFilters = _j[1];
    var savedFiltersRequestRef = useRef(false);
    var columnConfigRecordIdRef = useRef(null);
    var columnConfigRequestRef = useRef(false);
    var sanitizeVendor = useCallback(function (vendor) {
        var _a;
        return (__assign({ Id: (_a = vendor === null || vendor === void 0 ? void 0 : vendor.Id) !== null && _a !== void 0 ? _a : 'All' }, ((vendor === null || vendor === void 0 ? void 0 : vendor.Name) !== undefined ? { Name: vendor.Name } : {})));
    }, []);
    var sanitizeVendors = useCallback(function (vendors) { return (Array.isArray(vendors)
        ? vendors
            .filter(function (vendor) { return Boolean(vendor === null || vendor === void 0 ? void 0 : vendor.Id); })
            .map(function (vendor) { return sanitizeVendor(vendor); })
        : []); }, [sanitizeVendor]);
    var sanitizeUniqueStatusesForApply = useCallback(function (statuses) { return (Array.isArray(statuses)
        ? statuses
            .filter(function (status) { return Boolean(status === null || status === void 0 ? void 0 : status.label); })
            .map(function (status) {
            var _a;
            return (__assign({ label: status.label, value: (_a = status === null || status === void 0 ? void 0 : status.value) !== null && _a !== void 0 ? _a : null }, ((status === null || status === void 0 ? void 0 : status.statusGroup) !== undefined ? { statusGroup: status.statusGroup } : {})));
        })
        : []); }, []);
    var isSavedFilterEntry = function (item) {
        if (!item || typeof item !== 'object' || Array.isArray(item)) {
            return false;
        }
        return Boolean(item.label
            || item.name
            || item.FilterName
            || item.PreferenceName
            || item.value !== undefined
            || item.id !== undefined
            || item.Id !== undefined
            || item.RecordId !== undefined
            || item.OId !== undefined
            || item.PreferenceId !== undefined
            || item.FilterId !== undefined
            || item.filters
            || item.FilterData
            || item.PreferenceData
            || item.FilterConfig);
    };
    var normalizeSavedFilterOptions = useCallback(function (response) {
        var _a, _b, _c, _d, _e;
        var candidateCollections = [
            (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data,
            response === null || response === void 0 ? void 0 : response.data,
            (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.preferences,
            (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.savedFilters,
            (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.filters,
            (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.FilterConfig,
            response === null || response === void 0 ? void 0 : response.preferences,
            response === null || response === void 0 ? void 0 : response.savedFilters,
            response === null || response === void 0 ? void 0 : response.filters,
            response === null || response === void 0 ? void 0 : response.FilterConfig,
        ];
        var arrayCandidate = candidateCollections.find(function (item) { return Array.isArray(item); });
        var objectCandidate = candidateCollections.find(function (item) { return isSavedFilterEntry(item); });
        var rawFilters = arrayCandidate !== null && arrayCandidate !== void 0 ? arrayCandidate : (objectCandidate ? [objectCandidate] : []);
        return rawFilters
            .map(function (item, index) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return ({
                label: (_f = (_e = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.FilterName) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.label) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.name) !== null && _c !== void 0 ? _c : (_d = item === null || item === void 0 ? void 0 : item.FilterConfig) === null || _d === void 0 ? void 0 : _d.filterName) !== null && _e !== void 0 ? _e : item === null || item === void 0 ? void 0 : item.PreferenceName) !== null && _f !== void 0 ? _f : "Saved Filter ".concat(index + 1),
                value: (_o = (_m = (_l = (_k = (_j = (_h = (_g = item === null || item === void 0 ? void 0 : item.RecordId) !== null && _g !== void 0 ? _g : item === null || item === void 0 ? void 0 : item.Id) !== null && _h !== void 0 ? _h : item === null || item === void 0 ? void 0 : item.FilterId) !== null && _j !== void 0 ? _j : item === null || item === void 0 ? void 0 : item.value) !== null && _k !== void 0 ? _k : item === null || item === void 0 ? void 0 : item.id) !== null && _l !== void 0 ? _l : item === null || item === void 0 ? void 0 : item.OId) !== null && _m !== void 0 ? _m : item === null || item === void 0 ? void 0 : item.PreferenceId) !== null && _o !== void 0 ? _o : "".concat(index),
                filters: (_t = (_s = (_r = (_q = (_p = item === null || item === void 0 ? void 0 : item.FilterConfig) !== null && _p !== void 0 ? _p : item === null || item === void 0 ? void 0 : item.filters) !== null && _q !== void 0 ? _q : item === null || item === void 0 ? void 0 : item.FilterData) !== null && _r !== void 0 ? _r : item === null || item === void 0 ? void 0 : item.PreferenceData) !== null && _s !== void 0 ? _s : item === null || item === void 0 ? void 0 : item.data) !== null && _t !== void 0 ? _t : item,
            });
        })
            .filter(function (item) { return item.label && item.value !== undefined && item.value !== null; });
    }, []);
    var normalizeFilterToDraftPayload = useCallback(function (savedFilter) {
        var _a, _b, _c, _d, _e, _f, _g;
        var normalizedFilter = (savedFilter !== null && savedFilter !== void 0 ? savedFilter : {});
        var nestedFilterConfig = (_b = (_a = normalizedFilter.FilterConfig) !== null && _a !== void 0 ? _a : normalizedFilter.filterConfig) !== null && _b !== void 0 ? _b : {};
        var mergedFilter = __assign(__assign({}, nestedFilterConfig), normalizedFilter);
        var resolvedVendor = sanitizeVendor((_c = mergedFilter.vendor) !== null && _c !== void 0 ? _c : { Id: 'All', Name: 'All' });
        var resolvedVendors = Array.isArray(mergedFilter.portalName)
            ? sanitizeVendors(mergedFilter.portalName)
            : Array.isArray(mergedFilter.vendors)
                ? sanitizeVendors(mergedFilter.vendors)
                : (resolvedVendor === null || resolvedVendor === void 0 ? void 0 : resolvedVendor.Id) && resolvedVendor.Id !== 'All'
                    ? [resolvedVendor]
                    : [];
        var selectedVendorFromSavedFilter = (_d = resolvedVendors[0]) !== null && _d !== void 0 ? _d : resolvedVendor;
        var resolvedStatus = (_e = mergedFilter.statusGroup) !== null && _e !== void 0 ? _e : { label: '', value: null };
        var resolvedPrograms = Array.isArray(mergedFilter.programs) ? mergedFilter.programs : [];
        var resolvedUniqueStatus = Array.isArray(mergedFilter.status)
            ? sanitizeUniqueStatusesForApply(mergedFilter.status)
            : Array.isArray(mergedFilter.uniqueStatus)
                ? sanitizeUniqueStatusesForApply(mergedFilter.uniqueStatus)
                : [];
        var resolvedSalesRep = Array.isArray(mergedFilter.salesRep) ? mergedFilter.salesRep : [];
        var resolvedDealers = Array.isArray(mergedFilter.dealers) ? mergedFilter.dealers : [];
        var resolvedForecastDataRange = ((_f = mergedFilter.ForecastDataRange) === null || _f === void 0 ? void 0 : _f.StartDate)
            ? {
                StartDate: String(mergedFilter.ForecastDataRange.StartDate),
                EndDate: String(mergedFilter.ForecastDataRange.EndDate || mergedFilter.ForecastDataRange.StartDate),
            }
            : undefined;
        return __assign({ vendor: selectedVendorFromSavedFilter, statusGroup: resolvedStatus, programs: resolvedPrograms, searchText: (_g = mergedFilter.searchText) !== null && _g !== void 0 ? _g : '', uniqueStatus: resolvedUniqueStatus, salesRep: resolvedSalesRep, dealers: resolvedDealers }, (resolvedForecastDataRange ? { ForecastDataRange: resolvedForecastDataRange } : {}));
    }, [sanitizeUniqueStatusesForApply, sanitizeVendor, sanitizeVendors]);
    var toComparableFilterState = useCallback(function (payload) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            vendorId: String((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.vendor) === null || _a === void 0 ? void 0 : _a.Id) !== null && _b !== void 0 ? _b : 'All'),
            statusGroupValue: String((_d = (_c = payload === null || payload === void 0 ? void 0 : payload.statusGroup) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : ''),
            searchText: (_e = payload === null || payload === void 0 ? void 0 : payload.searchText) !== null && _e !== void 0 ? _e : '',
            programs: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.programs) ? payload.programs : [])
                .map(function (program) { var _a, _b, _c, _d; return String((_d = (_c = (_b = (_a = program === null || program === void 0 ? void 0 : program.value) !== null && _a !== void 0 ? _a : program === null || program === void 0 ? void 0 : program.Id) !== null && _b !== void 0 ? _b : program === null || program === void 0 ? void 0 : program.id) !== null && _c !== void 0 ? _c : program) !== null && _d !== void 0 ? _d : ''); })
                .sort(),
            uniqueStatus: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.uniqueStatus) ? payload.uniqueStatus : [])
                .map(function (status) {
                var _a, _b, _c;
                return ({
                    label: String((_a = status === null || status === void 0 ? void 0 : status.label) !== null && _a !== void 0 ? _a : ''),
                    value: String((_b = status === null || status === void 0 ? void 0 : status.value) !== null && _b !== void 0 ? _b : ''),
                    statusGroup: String((_c = status === null || status === void 0 ? void 0 : status.statusGroup) !== null && _c !== void 0 ? _c : ''),
                });
            })
                .sort(function (a, b) { return "".concat(a.label, "|").concat(a.value, "|").concat(a.statusGroup).localeCompare("".concat(b.label, "|").concat(b.value, "|").concat(b.statusGroup)); }),
            salesRep: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.salesRep) ? payload.salesRep : [])
                .map(function (salesRep) { var _a, _b; return String((_b = (_a = salesRep === null || salesRep === void 0 ? void 0 : salesRep.value) !== null && _a !== void 0 ? _a : salesRep === null || salesRep === void 0 ? void 0 : salesRep.label) !== null && _b !== void 0 ? _b : ''); })
                .sort(),
            dealers: (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.dealers) ? payload.dealers : [])
                .map(function (dealer) { var _a, _b, _c; return String((_c = (_b = (_a = dealer === null || dealer === void 0 ? void 0 : dealer.AccountAspireOId) !== null && _a !== void 0 ? _a : dealer === null || dealer === void 0 ? void 0 : dealer.value) !== null && _b !== void 0 ? _b : dealer === null || dealer === void 0 ? void 0 : dealer.label) !== null && _c !== void 0 ? _c : ''); })
                .sort(),
            ForecastDataRangeStartDate: (_g = (_f = payload === null || payload === void 0 ? void 0 : payload.ForecastDataRange) === null || _f === void 0 ? void 0 : _f.StartDate) !== null && _g !== void 0 ? _g : '',
            ForecastDataRangeEndDate: (_j = (_h = payload === null || payload === void 0 ? void 0 : payload.ForecastDataRange) === null || _h === void 0 ? void 0 : _h.EndDate) !== null && _j !== void 0 ? _j : '',
        });
    }, []);
    var fetchSavedFilters = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextSavedFilters, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (savedFiltersRequestRef.current)
                        return [2];
                    savedFiltersRequestRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({
                            endPoint: api_urls.ADMIN_PREFERENCES,
                            payLoad: { ConfigType: "APP_MANAGMENT_FILTER_CONFIG" },
                            showLoader: false,
                        })];
                case 2:
                    response = _a.sent();
                    nextSavedFilters = normalizeSavedFilterOptions(response);
                    setFetchedSavedFilters(nextSavedFilters);
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    setFetchedSavedFilters([]);
                    return [3, 5];
                case 4:
                    savedFiltersRequestRef.current = false;
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [normalizeSavedFilterOptions]);
    var handleSavedFilterCreated = useCallback(function (createdFilter) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (createdFilter) {
                        setFetchedSavedFilters(function (prev) {
                            var _a;
                            var existingIndex = prev.findIndex(function (item) { var _a, _b; return String(item.value) === String(createdFilter.value) || ((_a = item.label) === null || _a === void 0 ? void 0 : _a.trim()) === ((_b = createdFilter.label) === null || _b === void 0 ? void 0 : _b.trim()); });
                            if (existingIndex >= 0) {
                                var updated = __spreadArray([], prev, true);
                                updated[existingIndex] = __assign(__assign(__assign({}, updated[existingIndex]), createdFilter), { filters: (_a = createdFilter.filters) !== null && _a !== void 0 ? _a : updated[existingIndex].filters });
                                return updated;
                            }
                            return __spreadArray([createdFilter], prev, true);
                        });
                    }
                    return [4, fetchSavedFilters()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); }, [fetchSavedFilters]);
    useEffect(function () {
        fetchSavedFilters();
    }, [fetchSavedFilters]);
    var fetchColumnConfig = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, rawRecord, record, columnConfig_1, recordId, selectedKeys, error_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (columnConfigRequestRef.current)
                        return [2];
                    columnConfigRequestRef.current = true;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({
                            endPoint: api_urls.ADMIN_PREFERENCES,
                            payLoad: { ConfigType: "APP_MANAGMENT_COLUMN_CONFIG" },
                            showLoader: false,
                        })];
                case 2:
                    response = _d.sent();
                    rawRecord = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
                    record = Array.isArray(rawRecord) ? rawRecord[0] : (rawRecord !== null && rawRecord !== void 0 ? rawRecord : response === null || response === void 0 ? void 0 : response.data);
                    columnConfig_1 = record === null || record === void 0 ? void 0 : record.ColumnConfig;
                    recordId = (_c = (_b = record === null || record === void 0 ? void 0 : record.RecordId) !== null && _b !== void 0 ? _b : record === null || record === void 0 ? void 0 : record.Id) !== null && _c !== void 0 ? _c : null;
                    if (recordId !== null && recordId !== undefined) {
                        columnConfigRecordIdRef.current = recordId;
                    }
                    if (columnConfig_1 && typeof columnConfig_1 === 'object' && !Array.isArray(columnConfig_1)) {
                        selectedKeys = Object.keys(columnConfig_1)
                            .filter(function (key) { return Number(columnConfig_1[key]) === 1 && !FIXED_COLUMN_KEYS.includes(key); });
                        setVisibleColumnKeys(selectedKeys);
                        setHasColumnCustomization(true);
                    }
                    return [3, 5];
                case 3:
                    error_2 = _d.sent();
                    return [3, 5];
                case 4:
                    columnConfigRequestRef.current = false;
                    setIsColumnConfigLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [setVisibleColumnKeys]);
    var persistColumnConfig = useCallback(function (nextVisibleKeys) { return __awaiter(void 0, void 0, void 0, function () {
        var columnConfig, response, savedRecordId, error_3;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    columnConfig = {};
                    allBacklogColumns.forEach(function (col) {
                        columnConfig[col.key] = (FIXED_COLUMN_KEYS.includes(col.key) || nextVisibleKeys.includes(col.key)) ? 1 : 0;
                    });
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 4]);
                    return [4, api_service.post({
                            endPoint: api_urls.ADMIN_PREFERENCES,
                            payLoad: {
                                ConfigType: "APP_MANAGMENT_COLUMN_CONFIG",
                                RecordId: columnConfigRecordIdRef.current,
                                ColumnConfig: columnConfig,
                            },
                            showLoader: false,
                        })];
                case 2:
                    response = _k.sent();
                    savedRecordId = (_h = (_f = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.RecordId) !== null && _c !== void 0 ? _c : (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.Id) !== null && _f !== void 0 ? _f : (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.RecordId) !== null && _h !== void 0 ? _h : (_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.Id;
                    if (savedRecordId !== undefined && savedRecordId !== null) {
                        columnConfigRecordIdRef.current = savedRecordId;
                    }
                    return [3, 4];
                case 3:
                    error_3 = _k.sent();
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); }, []);
    useEffect(function () {
        fetchColumnConfig();
    }, [fetchColumnConfig]);
    var isVendorFilterApplied = Boolean((selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Id) && selectedVendor.Id !== 'All');
    var normalizedStatusValue = String((_b = (_a = selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.value) !== null && _a !== void 0 ? _a : selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.label) !== null && _b !== void 0 ? _b : '').trim();
    var isStatusFilterApplied = normalizedStatusValue !== '' &&
        normalizedStatusValue.toLowerCase() !== 'all';
    var isProgramsFilterApplied = Array.isArray(selectedPrograms) && selectedPrograms.length > 0;
    var isUniqueStatusFilterApplied = Array.isArray(selectedUniqueStatus) && selectedUniqueStatus.length > 0;
    var isSalesRepFilterApplied = Array.isArray(selectedSalesRep) && selectedSalesRep.length > 0;
    var isSearchFilterApplied = typeof searchText === 'string' && searchText.trim() !== '';
    var hasActiveFilters = isVendorFilterApplied
        || isStatusFilterApplied
        || isProgramsFilterApplied
        || isUniqueStatusFilterApplied
        || isSalesRepFilterApplied
        || isSearchFilterApplied
        || Boolean(selectedForecastDataRange === null || selectedForecastDataRange === void 0 ? void 0 : selectedForecastDataRange.StartDate);
    var buildActiveFiltersPayload = useCallback(function () { return (__assign({ vendor: selectedVendor, status: selectedStatus, programs: Array.isArray(selectedPrograms) ? selectedPrograms : [], searchText: searchText, uniqueStatus: Array.isArray(selectedUniqueStatus) ? selectedUniqueStatus : [], salesRep: Array.isArray(selectedSalesRep) ? selectedSalesRep : [], dealers: Array.isArray(selectedDealers) ? selectedDealers : [] }, ((selectedForecastDataRange === null || selectedForecastDataRange === void 0 ? void 0 : selectedForecastDataRange.StartDate) ? { ForecastDataRange: selectedForecastDataRange } : {}))); }, [selectedVendor, selectedStatus, selectedPrograms, searchText, selectedUniqueStatus, selectedSalesRep, selectedDealers, selectedForecastDataRange]);
    var applyFilterPatch = useCallback(function (patch) {
        setSelectedSavedFilter('');
        applyBacklogFilters(__assign(__assign({}, buildActiveFiltersPayload()), patch));
    }, [applyBacklogFilters, buildActiveFiltersPayload, setSelectedSavedFilter]);
    var activeFilterChips = useMemo(function () {
        var _a, _b;
        var chips = [];
        if (isVendorFilterApplied) {
            chips.push({
                id: 'vendor',
                label: (selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Name) || String((_a = selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Id) !== null && _a !== void 0 ? _a : ''),
                onRemove: function () { return applyFilterPatch({ vendor: { Id: 'All', Name: 'All' } }); },
            });
        }
        (Array.isArray(selectedDealers) ? selectedDealers : []).forEach(function (dealer) {
            chips.push({
                id: "dealer-".concat(dealer.value),
                label: dealer.label,
                onRemove: function () { return applyFilterPatch({
                    dealers: selectedDealers.filter(function (d) { return d.value !== dealer.value; }),
                }); },
            });
        });
        (Array.isArray(selectedPrograms) ? selectedPrograms : []).forEach(function (program) {
            var _a, _b, _c, _d;
            chips.push({
                id: "program-".concat((_b = (_a = program === null || program === void 0 ? void 0 : program.value) !== null && _a !== void 0 ? _a : program === null || program === void 0 ? void 0 : program.Id) !== null && _b !== void 0 ? _b : program === null || program === void 0 ? void 0 : program.id),
                label: (_d = (_c = program === null || program === void 0 ? void 0 : program.label) !== null && _c !== void 0 ? _c : program === null || program === void 0 ? void 0 : program.Name) !== null && _d !== void 0 ? _d : '',
                onRemove: function () { return applyFilterPatch({
                    programs: selectedPrograms.filter(function (p) { return p !== program; }),
                }); },
            });
        });
        (Array.isArray(selectedSalesRep) ? selectedSalesRep : []).forEach(function (rep) {
            chips.push({
                id: "salesrep-".concat(rep.value),
                label: rep.label,
                onRemove: function () { return applyFilterPatch({
                    salesRep: selectedSalesRep.filter(function (r) { return r.value !== rep.value; }),
                }); },
            });
        });
        if (isStatusFilterApplied) {
            chips.push({
                id: 'status-group',
                label: (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.label) || String((_b = selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.value) !== null && _b !== void 0 ? _b : ''),
                onRemove: function () { return applyFilterPatch({ status: { label: '', value: null }, uniqueStatus: [] }); },
            });
        }
        (Array.isArray(selectedUniqueStatus) ? selectedUniqueStatus : []).forEach(function (status) {
            chips.push({
                id: "status-".concat(status.value),
                label: status.label,
                onRemove: function () { return applyFilterPatch({
                    uniqueStatus: selectedUniqueStatus.filter(function (s) { return s.value !== status.value; }),
                }); },
            });
        });
        if (isSearchFilterApplied) {
            chips.push({
                id: 'search',
                label: "Search: ".concat(searchText),
                onRemove: function () { return applyFilterPatch({ searchText: '' }); },
            });
        }
        if (selectedForecastDataRange === null || selectedForecastDataRange === void 0 ? void 0 : selectedForecastDataRange.StartDate) {
            chips.push({
                id: 'forecast-date',
                label: selectedForecastDataRange.EndDate && selectedForecastDataRange.EndDate !== selectedForecastDataRange.StartDate
                    ? "".concat(selectedForecastDataRange.StartDate, " - ").concat(selectedForecastDataRange.EndDate)
                    : selectedForecastDataRange.StartDate,
                onRemove: function () { return applyFilterPatch({ ForecastDataRange: undefined }); },
            });
        }
        return chips;
    }, [
        isVendorFilterApplied,
        selectedVendor,
        selectedDealers,
        selectedPrograms,
        selectedSalesRep,
        isStatusFilterApplied,
        selectedStatus,
        selectedUniqueStatus,
        isSearchFilterApplied,
        searchText,
        selectedForecastDataRange,
        applyFilterPatch,
    ]);
    var handleClearAllFilters = useCallback(function () {
        setSelectedSavedFilter('');
        handleResetFilters();
    }, [handleResetFilters, setSelectedSavedFilter]);
    var hasSelectedSavedFilter = selectedSavedFilter !== '' && selectedSavedFilter !== null && selectedSavedFilter !== undefined;
    var selectedToolbarSavedFilterItem = useMemo(function () { return fetchedSavedFilters.find(function (item) { return String(item.value) === String(selectedSavedFilter); }); }, [fetchedSavedFilters, selectedSavedFilter]);
    var isToolbarSavedFilterDirty = useMemo(function () {
        if (filterOpen) {
            return false;
        }
        if (!selectedSavedFilter || !selectedToolbarSavedFilterItem) {
            return false;
        }
        var selectedFilterPayload = normalizeFilterToDraftPayload(selectedToolbarSavedFilterItem.filters);
        var currentFilterPayload = __assign({ vendor: sanitizeVendor(selectedVendor), statusGroup: selectedStatus, programs: Array.isArray(selectedPrograms) ? selectedPrograms : [], searchText: searchText, uniqueStatus: sanitizeUniqueStatusesForApply(Array.isArray(selectedUniqueStatus) ? selectedUniqueStatus : []), salesRep: Array.isArray(selectedSalesRep) ? selectedSalesRep : [], dealers: Array.isArray(selectedDealers) ? selectedDealers : [] }, ((selectedForecastDataRange === null || selectedForecastDataRange === void 0 ? void 0 : selectedForecastDataRange.StartDate)
            ? { ForecastDataRange: selectedForecastDataRange }
            : {}));
        return JSON.stringify(toComparableFilterState(currentFilterPayload)) !== JSON.stringify(toComparableFilterState(selectedFilterPayload));
    }, [
        normalizeFilterToDraftPayload,
        sanitizeUniqueStatusesForApply,
        sanitizeVendor,
        searchText,
        selectedPrograms,
        selectedSalesRep,
        selectedDealers,
        selectedSavedFilter,
        selectedStatus,
        selectedToolbarSavedFilterItem,
        selectedUniqueStatus,
        selectedVendor,
        selectedForecastDataRange,
        filterOpen,
        toComparableFilterState,
    ]);
    var handleSavedFilterChange = useCallback(function (selectedFilterValue) {
        if (selectedFilterValue === '' || selectedFilterValue === null || selectedFilterValue === undefined) {
            return;
        }
        var selectedSavedFilterItem = fetchedSavedFilters.find(function (item) { return String(item.value) === String(selectedFilterValue); });
        if (!(selectedSavedFilterItem === null || selectedSavedFilterItem === void 0 ? void 0 : selectedSavedFilterItem.filters)) {
            return;
        }
        var savedFilterPayload = normalizeFilterToDraftPayload(selectedSavedFilterItem.filters);
        applyBacklogFilters(__assign({ vendor: savedFilterPayload.vendor, status: savedFilterPayload.statusGroup, programs: savedFilterPayload.programs, searchText: savedFilterPayload.searchText, uniqueStatus: savedFilterPayload.uniqueStatus, salesRep: savedFilterPayload.salesRep, dealers: savedFilterPayload.dealers }, (savedFilterPayload.ForecastDataRange
            ? { ForecastDataRange: savedFilterPayload.ForecastDataRange }
            : {})));
        setSelectedSavedFilter(selectedFilterValue);
    }, [fetchedSavedFilters, normalizeFilterToDraftPayload, applyBacklogFilters, setSelectedSavedFilter]);
    var handleClearSavedFilter = useCallback(function () {
        handleResetFilters();
    }, [handleResetFilters]);
    var handleApplicatonClick = function (rowData) {
        var _a, _b, _c;
        if (rowData === null || rowData === void 0 ? void 0 : rowData.TxAspireOId) {
            var url = "".concat(navConfig.BacklogAppDetails, "/").concat(rowData.TxAspireOId);
            navigate(url, {
                state: {
                    status: (_c = (_b = (_a = rowData === null || rowData === void 0 ? void 0 : rowData.Status) !== null && _a !== void 0 ? _a : rowData === null || rowData === void 0 ? void 0 : rowData.status) !== null && _b !== void 0 ? _b : rowData === null || rowData === void 0 ? void 0 : rowData.AspireStatus) !== null && _c !== void 0 ? _c : null,
                    activeTab: activeTab,
                },
            });
        }
    };
    var tabTrailingContent = (React.createElement(Stack, { direction: "row", alignItems: "center", gap: 2, className: "backlog-toolbar-controls", sx: { minWidth: 0, flexWrap: 'nowrap' } },
        React.createElement(Box, { sx: { minWidth: 0, flexShrink: 0 } },
            React.createElement(ActiveFilterChipsRow, { chips: activeFilterChips, onOverflowClick: function () { setFilterOpen(true); setColumnSettingsOpen(false); }, onClearAll: handleClearAllFilters })),
        React.createElement(Box, { sx: { position: 'relative', width: '200px', flexShrink: 0 } },
            React.createElement(Select, { displayEmpty: true, value: selectedSavedFilter, onChange: function (e) { return handleSavedFilterChange(e.target.value); }, size: "small", sx: {
                    backgroundColor: baseColors.fullWhite,
                    width: '100%',
                    fontSize: 13,
                    '& .MuiSelect-select': {
                        pr: hasSelectedSavedFilter ? '56px' : '32px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: isToolbarSavedFilterDirty ? baseColors.errorPreset[20] : baseColors.greyPreset[20],
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: isToolbarSavedFilterDirty ? baseColors.errorPreset[10] : baseColors.successPreset[10],
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: isToolbarSavedFilterDirty ? baseColors.errorPreset[20] : baseColors.successPreset[30],
                    },
                    '& .MuiSelect-icon': {
                        right: hasSelectedSavedFilter ? 28 : undefined,
                        color: isToolbarSavedFilterDirty ? baseColors.errorPreset[20] : undefined,
                    },
                }, renderValue: function (val) {
                    var _a;
                    if (val === '' || val === null || val === undefined) {
                        return React.createElement("span", { style: { color: baseColors.greyPreset[30], fontSize: 13 } }, "Select Saved Filter");
                    }
                    var selectedOptionLabel = (_a = fetchedSavedFilters.find(function (f) { return String(f.value) === String(val); })) === null || _a === void 0 ? void 0 : _a.label;
                    if (!selectedOptionLabel) {
                        return React.createElement("span", { style: { color: baseColors.greyPreset[30], fontSize: 13 } }, "Select Saved Filter");
                    }
                    return (React.createElement("span", { style: {
                            fontSize: 13,
                            color: isToolbarSavedFilterDirty ? baseColors.errorPreset[20] : baseColors.darkPreset[10],
                        } }, selectedOptionLabel));
                } },
                fetchedSavedFilters.length === 0 && (React.createElement(MenuItem, { value: "", sx: { fontSize: 13 } },
                    React.createElement("em", null, "None"))),
                fetchedSavedFilters.map(function (f) { return (React.createElement(MenuItem, { key: f.value, value: f.value, sx: { fontSize: 13 } }, f.label)); })),
            hasSelectedSavedFilter && (React.createElement(IconButton, { size: "small", onMouseDown: function (e) { return e.preventDefault(); }, onClick: function (e) {
                    e.stopPropagation();
                    handleClearSavedFilter();
                }, sx: {
                    position: 'absolute',
                    right: 4,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    p: '2px',
                    zIndex: 1,
                    color: baseColors.greyPreset[30],
                } },
                React.createElement(CloseIcon, { sx: { fontSize: 14 } })))),
        React.createElement(CustomButton, { MDButton: true, variant: "outlined", startIcon: React.createElement(ViewColumnOutlinedIcon, { sx: { fontSize: 18 } }), onClick: function () { setColumnSettingsOpen(function (prev) { return !prev; }); setFilterOpen(false); }, fullWidth: false, iconSize: 18, sx: { flexShrink: 0 } }, "Columns"),
        React.createElement(CustomButton, { MDButton: true, variant: hasActiveFilters ? 'contained' : 'outlined', startIcon: React.createElement("span", { className: 'icon-Filters' }), onClick: function () {
                if (filterOpen) {
                    setFilterOpen(false);
                    return;
                }
                setFilterOpen(true);
                setColumnSettingsOpen(false);
            }, fullWidth: false, iconSize: 18, sx: { flexShrink: 0 } }, "Filter")));
    var sharedDealsContent = (React.createElement(React.Fragment, null,
        React.createElement(BacklogViewWrapper, { className: "backlogQueueView" },
            React.createElement(Box, { className: "backlogMainContent" }, viewMode === 'list' ? (isColumnConfigLoading ? (null) : (React.createElement(BacklogTableSection, { backlogAppList: backlogAppList, isFetching: isFetching, currentPage: currentPage, perPageCount: perPageCount, setCurrentPage: setCurrentPage, setPerPageCount: setPerPageCount, totalCount: totalCount, handleApplicatonClick: handleApplicatonClick, sortBy: sortBy, sortOrder: sortOrder, handleSortChange: handleTableSortChange, visibleColumnKeys: visibleColumnKeys }))) : (React.createElement(BacklogApplicationCardView, { backlogAppList: backlogAppList, onCardClick: handleApplicatonClick, currentPage: currentPage, perPageCount: perPageCount, setCurrentPage: setCurrentPage, setPerPageCount: setPerPageCount, totalCount: totalCount }))),
            filterOpen && (React.createElement(Box, { className: "backlogFilters" },
                React.createElement(Filter, { vendorList: vendorList !== null && vendorList !== void 0 ? vendorList : [], selectedVendor: selectedVendor, selectedStatus: selectedStatus, searchText: searchText, selectedUniqueStatus: selectedUniqueStatus, uniqueStatusList: allUniqueStatusList, handleResetFilters: handleResetFilters, programsList: programsList, fetchProgramsByVendor: fetchProgramsByVendor, salesRepList: salesRepList, selectedPrograms: selectedPrograms, selectedSavedFilter: selectedSavedFilter, setSelectedSavedFilter: setSelectedSavedFilter, onSaveAsNewFilter: handleSavedFilterCreated, applyBacklogFilters: applyBacklogFilters, onApply: function () { return setFilterOpen(false); }, onCancel: function () { return setFilterOpen(false); }, selectedSalesRep: selectedSalesRep, selectedDealers: selectedDealers, selectedDateRange: selectedForecastDataRange, fetchSalesRepList: fetchSalesRepList, dealersList: dealerList, dealersLoading: dealerListLoading, dealersLoadingMore: dealerListLoadingMore, dealersHasMore: dealerListHasMore, dealersError: dealerListError, fetchDealersByVendor: fetchDealersByVendor, searchDealerList: searchDealerList, loadMoreDealerList: loadMoreDealerList }))),
            columnSettingsOpen && (React.createElement(Box, { className: "backlogFilters" },
                React.createElement(ColumnSettings, { loading: isColumnConfigLoading, allColumns: allBacklogColumns
                        .filter(function (col) { return !FIXED_COLUMN_KEYS.includes(col.key); })
                        .map(function (col) { return ({ key: col.key, header: col.header }); }), visibleColumnKeys: visibleColumnKeys, onSave: function (keys) {
                        setVisibleColumnKeys(keys);
                        setHasColumnCustomization(true);
                        persistColumnConfig(keys);
                        setColumnSettingsOpen(false);
                    }, onCancel: function () { return setColumnSettingsOpen(false); }, onReset: function () {
                        setVisibleColumnKeys(defaultVisibleColumnKeys);
                        setHasColumnCustomization(true);
                        persistColumnConfig(defaultVisibleColumnKeys);
                    } })))),
        React.createElement(BacklogPagination, { currentPage: currentPage, perPageCount: perPageCount, totalCount: totalCount, onPageChange: setCurrentPage, onPerPageChange: function (count) {
                setPerPageCount(count);
                setCurrentPage(1);
            }, className: "backlog-list-pagination", resetOnFirstLoad: false })));
    var tabs = [
        {
            label: 'Backlog Queue',
            content: sharedDealsContent,
        },
        { label: 'All Deals', content: sharedDealsContent },
    ];
    var uiActiveTabIndex = activeTab === 1 ? 1 : 0;
    var handleTabChange = function (nextTabIndex) {
        setFilterOpen(false);
        setColumnSettingsOpen(false);
        var nextReduxTab = nextTabIndex === 1 ? 1 : 0;
        if (nextReduxTab !== activeTab) {
            dispatch(backlog_actions.setActiveTab(nextReduxTab));
        }
    };
    return (React.createElement(Box, { className: "backlogApplicationWrapper", pt: 1.5, sx: {
            height: 'calc(100vh - 45px)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            '& .backlogQueueInner': { flex: '1 1 auto', minHeight: 0 },
            '& .backlogQueueView': { flex: '1 1 auto', minHeight: 0 },
        } },
        React.createElement(Stack, { px: 3, gap: 1, className: "backlogQueueInner" },
            React.createElement(Stack, { direction: "row", justifyContent: "flex-end" },
                React.createElement(CreateApplicationButton, null)),
            React.createElement(CommonTab, { tabs: tabs, activeIndex: uiActiveTabIndex, onTabChange: handleTabChange, trailingContent: tabTrailingContent }))));
};
export default BacklogApplication;
